export default __webpack_public_path__ + "static/media/22.39650652.jpg";